// Admin REST:
export const ADMIN_BASE_URL = process.env.VUE_APP_ADMIN_BASE_URL
export const ADMIN_SCENARIOS_API_URL = ADMIN_BASE_URL + "scenarios/"
export const ADMIN_CASES_API_URL = ADMIN_BASE_URL + "cases/"
export const ADMIN_EDIT_RPS_SCENARIOS_API_URL = ADMIN_BASE_URL + "edit/rps/scenarios/"
export const ADMIN_EDIT_RPS_SIMULATIONS_API_URL = ADMIN_BASE_URL + "edit/rps/simulations/"
export const ADMIN_RPS_CASE_CHOICES_API_URL = ADMIN_BASE_URL + "rps/case_choices/"
export const ADMIN_GAMES_API_URL = ADMIN_BASE_URL + "games/"
export const ADMIN_GAMES_HISTORY_API_URL = ADMIN_BASE_URL + "games_history/"
export const ADMIN_PLAYERS_PATCH_API_URL = ADMIN_BASE_URL + "players/"
export const ADMIN_PLAYERS_DELETE_API_URL = ADMIN_BASE_URL + "players/"
export const ADMIN_PLAYERS_GET_API_URL = ADMIN_BASE_URL + "players/facilitator/"
export const ADMIN_USERS_API_URL = ADMIN_BASE_URL + "users/"
export const ADMIN_EMAIL_FORGOT_PASSWORD_LINK_API_URL = ADMIN_BASE_URL + "forgotpassword/"
export const ADMIN_CHANGE_PASSWORD_API_URL = ADMIN_BASE_URL + "changepassword/"
export const ADMIN_COMMENTS_API_URL = ADMIN_BASE_URL + "comments/"
export const ADMIN_FACILITATOR_INSTRUCTIONS_API_URL = ADMIN_BASE_URL + "facilitatorinstructions/"
export const ADMIN_EMAIL_REPORT_LINK_API_URL = ADMIN_BASE_URL + "emailreportlink/"
export const ADMIN_EMAIL_RETURN_LINK_API_URL = ADMIN_BASE_URL + "emailreturnlink/"
export const ADMIN_GAME_CASE_OPTIONS_API_URL = ADMIN_BASE_URL + "gamecaseoptions/"
export const ADMIN_CHANGE_FACILITATOR_NAME_API_URL = ADMIN_BASE_URL + "changefacilitatorname/"
export const ADMIN_NEWS_API_URL = ADMIN_BASE_URL + "news/"
export const ADMIN_NOTIFICATIONS_API_URL = ADMIN_BASE_URL + "notifications/"
export const ADMIN_CLONE_SCENARIO_API_URL = ADMIN_BASE_URL + "scenarios/"
export const ADMIN_RPS_SCENARIOS_API_URL = ADMIN_BASE_URL + "rps/scenarios/"
export const ADMIN_RPS_CASES_API_URL = ADMIN_BASE_URL + "rps/cases/"
export const ADMIN_PARTNER_INVOICE_API_URL = ADMIN_BASE_URL + "invoicing/games/"
export const ADMIN_SPEAKING_TURNS_API_URL = ADMIN_BASE_URL + "speakingturns/"
export const ADMIN_EDIT_PHOTOS_RPS_SCENARIOS_API_URL = ADMIN_BASE_URL + "edit/photos/rps/scenarios/"
export const ADMIN_EDIT_PHOTOS_RPS_CASES_API_URL = ADMIN_BASE_URL + "edit/photos/rps/scenarios/"
export const ADMIN_FEEDBACK_API_URL = ADMIN_BASE_URL + "feedback/"
// Following are for game:
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL
export const SOCKET_URL = process.env.VUE_APP_SOCKER_URL
export const USERS_API_URL = API_BASE_URL + "users/"
export const CASES_API_URL = API_BASE_URL + "cases/"
export const SCENARIOS_API_URL = API_BASE_URL + "scenarios/"
export const NOMINATIONS_API_URL = API_BASE_URL + "nominations/"
export const GAMES_API_URL = API_BASE_URL + "games/"
export const SELF_EVALUATIONS_API_URL = API_BASE_URL + "selfevaluations/"
export const PLAYERS_API_URL = API_BASE_URL + "players/"
export const COMMENTS_API_URL = API_BASE_URL + "comments/"
export const SUGGESTIONS_API_URL = API_BASE_URL + "suggestions/"
export const ACTION_PLAN_VOTES_API_URL = API_BASE_URL + "action_plan_votes/"
export const SURVEYS_API_URL = API_BASE_URL + "surveys/"
export const GAME_CASE_OPTIONS_API_URL = API_BASE_URL + "gamecaseoptions/"
export const FEEDBACK_API_URL = API_BASE_URL + "feedback/"
export const RPS_CASES_API_URL = API_BASE_URL + "rps/cases/"
export const RPS_SCENARIOS_API_URL = API_BASE_URL + "rps/scenarios/"
export const RPS_CASE_CHOICES_API_URL = API_BASE_URL + "rps/casechoices/"
export const RPS_ANSWERS_API_URL = API_BASE_URL + "rps/answers/"
export const PLAYERS_PAUSE_REMOVE_API_URL = `${API_BASE_URL}players/pause/remove/`;
// Amazon translate:
export const TRANSLATE_API_URL = ADMIN_BASE_URL + "translate/"
// RPS Template:
export const ADMIN_RPS_TEMPLATE_CATEGORIES_API_URL = ADMIN_BASE_URL + "rps/template/categories/"
export const ADMIN_RPS_TEMPLATE_CASES_API_URL = ADMIN_BASE_URL + "rps/template/cases/"
export const ADMIN_RPS_TEMPLATE_CASE_CHOICES_API_URL = ADMIN_BASE_URL + "rps/template/case_choices/"
export const ADMIN_RPS_SCENARIOS_TEMPLATES_API_URL = ADMIN_BASE_URL + "rps/scenarios/templates"
export const ADMIN_RPS_CASES_TEMPLATES_API_URL = ADMIN_BASE_URL + "rps/cases/templates"
export const ADMIN_RPS_CASE_CHOICES_TEMPLATES_API_URL = ADMIN_BASE_URL + "rps/case_choices/templates"
